import { render, staticRenderFns } from "./FrzCtnPalletSamplingNewVP.vue?vue&type=template&id=8427e824"
import script from "./FrzCtnPalletSamplingNewVP.vue?vue&type=script&lang=js"
export * from "./FrzCtnPalletSamplingNewVP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports